import React, { useState } from 'react';

import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";

import InputView from 'views/widgets/InputView.jsx';

export default function QueryViewStyleDialog(props) {
	
	const { initStyles, includeFieldStyleInputs, okCallback, cancelCallback } = props;
	const fontSizes = [
		{ text: "8pt" },
		{ text: "9pt" },
		{ text: "10pt" },
		{ text: "11pt" },
		{ text: "12pt" },
		{ text: "14pt" },
		{ text: "18pt" },
		{ text: "24pt" },
	];
	
	const [styles, setStyles] = useState(initStyles);

	const stripPx = (style) => {
		let pxIdx = style.indexOf("px");
		return parseInt(style.substring(0, pxIdx));
	};
	
	const onChanged = (styleName, styleValue) => {
		let newStyles = JSON.parse(JSON.stringify(styles));
		newStyles[styleName] = styleValue;
		setStyles(newStyles);
	};
	
	const getFieldStyleInputs = () => {
		let inputs = [];
		inputs.push(<InputView key={"width"} field={"width"} type={"number"} label={"Width: "}
						readOnly={false} required={false} hidden={false} 
						onChange={(e) => { onChanged('width', e.value); }}
						defaultValue={200}
						value={(styles.width != undefined && styles.width != null ? styles.width : 200)} />);
		inputs.push(<InputView key={"height"} field={"height"} type={"number"} label={"Height: "}
						readOnly={false} required={false} hidden={false} 
						onChange={(e) => { onChanged('height', e.value); }}
						defaultValue={30}
						value={(styles.height != undefined && styles.height != null ? styles.height : 30)} />);
						
		return inputs;						
	};

	return (
		<Dialog style={{zIndex: "120", overflow: "auto"}} title={"Edit Appearance"} onClose={cancelCallback}>
	    	<div className=".constituo-add-modify-layout-container">
	    		{ includeFieldStyleInputs && getFieldStyleInputs() }
				<InputView key={"color"} field={"color"} type={"color"} label={"Color: "}
					readOnly={false} required={false} hidden={false} 
					views={['gradient', 'palette']}
					onChange={(e) => { onChanged('color', e.value); }}
					defaultValue={styles.color}
					value={styles.color} />
				<InputView key={"backgroundColor"} field={"backgroundColor"} type={"color"} label={"Background Color: "}
					readOnly={false} required={false} hidden={false} 
					defaultValue={styles.backgroundColor}
					onChange={(e) => { onChanged('backgroundColor', e.value); }}
					value={styles.backgroundColor} />	
				<InputView key={"fontSize"} field={"fontSize"} type={"combobox"} label={"Font Size: "}
					readOnly={false} required={false} hidden={false} 
					onChange={(e) => { onChanged('fontSize', e.value.text); }}
					data={fontSizes} dataItemKey={"text"} textField={"text"}
					value={{text: styles.fontSize}} />
				<InputView key={"padding"} field={"padding"} type={"number"} label={"Padding: "}
					readOnly={false} required={false} hidden={false} 
					defaultValue={stripPx(styles.padding)}
					onChange={(e) => { onChanged('padding', e.value + "px"); }}
					value={stripPx(styles.padding)} />	

			</div>
	        <DialogActionsBar>
	        	{okCallback && 
	        		<button
	            		className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
	              		onClick={() => { okCallback(styles); }}
	            	>
	            		Ok
	            	</button>
	            }
	            {cancelCallback && 
	            	<button
	            		className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
	            		onClick={cancelCallback}
	            	>
	            		Cancel
	            	</button>
	            }
	        </DialogActionsBar>
		</Dialog>
	);
}